import { z } from 'zod'
import { candleSchema } from './candle.schema'

// the compact price chart shows either the last week or the last month of candles.
export const historyIndexRangeSchema = z.enum(['week', 'month'])
export type HistoryIndexRange = z.infer<typeof historyIndexRangeSchema>

export const historyIndexQuerySchema = z.object({
  range: historyIndexRangeSchema.default('week'),
})
export type HistoryIndexQueryDto = z.infer<typeof historyIndexQuerySchema>

// a single period change: absolute point move and its percent, both null when the
// series lacks enough history to compute the window.
export const indexDeltaSchema = z.object({
  absolute: z.number(),
  percent: z.number(),
})
export type IndexDeltaDto = z.infer<typeof indexDeltaSchema>

export const indexDeltasSchema = z.object({
  day: indexDeltaSchema.nullable(),
  week: indexDeltaSchema.nullable(),
  month: indexDeltaSchema.nullable(),
  year: indexDeltaSchema.nullable(),
})
export type IndexDeltasDto = z.infer<typeof indexDeltasSchema>

// index overview: current value, the four period deltas and the candle series for the
// selected chart range. `series` uses the shared CandleDto shape.
export const historyIndexResponseSchema = z.object({
  ticker: z.string(),
  name: z.string(),
  uid: z.string(),
  currency: z.string(),
  currentValue: z.number(),
  deltas: indexDeltasSchema,
  series: z.array(candleSchema),
})
export type HistoryIndexResponseDto = z.infer<typeof historyIndexResponseSchema>
